import { REPO_TYPE } from '../const.tsx';
import linkMessages from './link-messages.tsx';
import repoMessages from './repo-messages.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (type: string) => {
	if (type === REPO_TYPE) {
		return repoMessages;
	}
	return linkMessages;
};
